import React from 'react';
import { Container, Row, Col, Form } from 'reactstrap';
import PropTypes from 'prop-types';
import { withLocale } from '@dietlabs/components';
import InputSwitch from '../../components/FormElements/InputSwitchControlled2';
import withLoading from '../../Layout/withLoading';
import NotificationsSettingsFormPlaceholder from './NotificationsSettingsFormPlaceholder';

export const NotificationsSettings = props => {
    const handleInputChange = event => {
        if (event.target.name === 'dietCourse') {
            props.onDietCourseChange(event.target.checked);
        }

        if (event.target.name === 'newsletter') {
            props.onNewsletterChange(event.target.checked);
        }
    };

    return (
        <Container className={props.className}>
            <Row>
                <Col xs="12" md={{ size: 8, offset: 2 }}>
                    <div className="white-box">
                        <Form>
                            <h2>{props.t('settings/notifications')}</h2>

                            <InputSwitch
                                label={props.t(
                                    'settings/agreements/diet-course'
                                )}
                                id="dietCourse"
                                name="dietCourse"
                                value={props.agreements.dietCourse}
                                handleChange={handleInputChange}
                                checked={props.agreements.dietCourse}
                            />
                            <InputSwitch
                                label={props.t(
                                    'settings/agreements/newsletter'
                                )}
                                id="newsletter"
                                name="newsletter"
                                value={props.agreements.newsletter}
                                handleChange={handleInputChange}
                                checked={props.agreements.newsletter}
                            />
                            <p>
                                {props.t('settings/agreements/newsletter-info')}
                            </p>
                            {props.children}
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

NotificationsSettings.propTypes = {
    className: PropTypes.string,
    agreements: PropTypes.shape({
        dietCourse: PropTypes.bool.isRequired,
        newsletter: PropTypes.bool.isRequired,
    }).isRequired,
    onDietCourseChange: PropTypes.func.isRequired,
    onNewsletterChange: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    children: PropTypes.node,
};

NotificationsSettings.defaultProps = {
    className: null,
    children: null,
};

export default withLoading(
    withLocale(NotificationsSettings),
    NotificationsSettingsFormPlaceholder
);
